export enum ItemType {
  FREEFORM = 'FREEFORM',
  INFOLINE = 'INFOLINE',
}
